<template>
  <!-- <div class="page-footer">
    <div class="container container-wide text-md-left">
            <div class="row row-50 section-60 section-lg-90 d-flex justify-center" style="padding-bottom:30px;">
              <div class="col-md-6 col-xl-4 mb-0"><a class="d-inline-block"><img class="img-responsive center-block" :src="require('@/assets/images/image.png')" alt="" style="width:110px;height:100px;filter: brightness(0) invert(1);"></a>
                <p class="d-none">SkyBooking is a travel search engine which instantly searches all available flight, bus and train prices on an exhaustive number of travel sites such as online travel agencies, major and low-cost airlines and tour-operators.</p>
                
                 <ul class="list-inline">
                  <li><a class="icon fa-facebook"></a></li>
                  <li><a class="icon fa-twitter"></a></li>
                  <li><a class="icon fa-pinterest-p"></a></li>
                  <li><a class="icon fa-vimeo"></a></li>
                  <li><a class="icon fa-google-plus"></a></li>
                  <li><a class="icon fa-rss"></a></li>
                </ul>
  
              </div>
              <div class="col-md-6 col-xl-3 d-none">
                <div class="inset-xxl-left-50">
                  <h5 class="text-bold">What People Say</h5>
                  <hr class="divider divider-50 divider-info divider-sm-left">
                  <div class="owl-carousel owl-dots-left owl-dots-white" data-dots="true" data-items="1" data-margin="30" data-mouse-drag="false">
                    <blockquote class="quote quote-sm">
                      <p>
                        <q>“I must tell you how impressed I am by your customer service. I have contacted you twice now and each time I received a prompt reply plus the additional attention of a manager. I have never received this kind of response from any other airline tickets booking site.”</q>
                      </p>
                      <p>
                        <cite>Phillip Holland</cite>
                      </p>
                    </blockquote>
                    <blockquote class="quote quote-sm">
                      <p>
                        <q>“I found your web site very easy to use. The entire process was very quick, and the price of my ticket was very affordable.”</q>
                      </p>
                      <p>
                        <cite>Amber Barnett</cite>
                      </p>
                    </blockquote>
                    <blockquote class="quote quote-sm">
                      <p>
                        <q>“Thank you for making it so easy. I really love the way I can view the itinerary and put payment info on the same page!”</q>
                      </p>
                      <p>
                        <cite>Ralph Green</cite>
                      </p>
                    </blockquote>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-xl-3 d-flex flex-column mb-0">
                 <a href="/aboutUs" target="_blank" class="mb-2" style="color: white; text-decoration: none">About Us</a>
                 <a href="/privacy-policy" target="_blank" class="mb-2" style="color: white; text-decoration: none">Privacy Policy</a>
                 <a href="/contactus" target="_blank" class="mb-2" style="color: white; text-decoration: none">Contct Us</a>
                 <a href="/termsofuse" target="_blank" class="mb-2" style="color: white; text-decoration: none">Terms of Use</a>
  
              </div>
              <div class="col-md-6 col-xl-4 mb-0">
                <div class="inset-xxl-left-50">
                  <form class="rd-mailform rd-form text-md-left" data-form-output="form-output-global" data-form-type="contact" method="post" action="bat/rd-mailform.php">
                    <div class="form-wrap form-wrap-sm">
                      <label class="text-gray-light form-label" for="footer-name">Your name</label>
                      <input class="form-input form-input-dark" id="footer-name" type="text" name="name" data-constraints="@Required">
                    </div>
                    <div class="form-wrap form-wrap-sm">
                      <label class="text-gray-light form-label" for="footer-email">Your e-mail</label>
                      <input class="form-input form-input-dark" id="footer-email" type="email" name="email" data-constraints="@Email @Required">
                    </div>
                    <button class="button button-primary button-xs button-naira button-naira-up" type="submit"><span class="icon fa-envelope-o"></span><span>Send</span></button>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="d-none container container-wide page-footer-min small">
            <div class="row row-20 justify-content-end-xs-middle">
              <div class="col-md-6 text-md-left">
                
              </div>
              <div class="col-md-6 text-md-right">
                <p class="rights"><span>&copy;&nbsp;</span><span class="copyright-year"></span><span>&nbsp;</span><span>All Rights Reserved</span><span>.&nbsp;</span><a href="privacy-policy.html">Privacy Policy</a></p>
              </div>
            </div>
          </div>
      </div> -->
  
      <footer class="page-footer">
          <div class="container text-md-left">
            <div class="d-flex flex-md-row flex-column justify-content-between gap-3 pb-4 ps-lg-0 ps-5" style="padding-top:45px;">
              <div class=""><a class="d-inline-block"><img class="img-responsive center-block" :src="portalLogo" style="width:150px;height:35px;"></a>
                <div style="font-size:15px;color:white;margin-top: 10px;">TRAVEL2TRAVEL4  helps you find the<br/> best fares with multiple options.</div>
              </div>
              <div class="d-none col-md-6 col-xl-3">
                <h5 class="text-bold">Latest Blog Posts</h5>
                <hr class="divider divider-50 divider-info divider-sm-left">
                <div class="unit flex-column flex-md-row">
                  <div class="unit-left"><img class="img-responsive center-block" src="../assets/images/footer-01.jpg" width="100" height="10" alt=""></div>
                  <div class="unit-body"><span class="extra-small">Sep 8, 2019</span>
                    <p class="text-bold"><a href="blog-single-post.html">How These 5 People Found The Path to Their Dream Trip</a></p>
                  </div>
                </div>
                <div class="unit flex-column flex-md-row">
                  <div class="unit-left"><img class="img-responsive center-block" src="../assets/images/footer-02.jpg" width="100" height="10" alt=""></div>
                  <div class="unit-body"><span class="extra-small">Sep 8, 2019</span>
                    <p class="text-bold"><a href="blog-single-post.html">The Ultimate Packing List for Female Travelers: 10 Useful Tips</a></p>
                  </div>
                </div>
              </div>
              <div class="">
          <h5 class="text-bold">Subscribe to Our Newsletter</h5>
          <v-form @submit.prevent="handleSendClick" ref="myForm" class="rd-mailform rd-form text-md-left mt-4">
            <div class="form-wrap form-wrap-sm">
              <input type="text" class="mailtextfield mb-2 form-input form-input-dark subscribe" id="footer-email" v-model="subEmail" placeholder="Your e-mail" required>
              <span v-if="!validEmail" class="error-message">Please enter a valid email.</span>
            </div>
            <div class="form-wrap form-wrap-sm">
              <input v-model="phoneNumber" class="form-input form-input-dark subscribe" id="footer-phone" placeholder="Your Phone Number" type="text">
            </div>

            <!-- Captcha Box -->
            <div v-if="showCaptcha" class="mt-2 captcha-container" ref="captchaContainer">
              <v-card width="180px" class="pa-2 captchasection mb-2" style="border: 1px solid gray">
                <div class="d-flex justify-content-between align-items-center" style="background-color: #213d77; height: 38px; padding: 12px;">
                  <canvas ref="myCanvas" width="110" height="35" style="background: white;"></canvas>
                  <v-icon @click="generateCaptcha()" color="white" size="16" style="cursor: pointer">mdi-reload</v-icon>
                </div>
                <v-text-field class="mt-2 v-none" placeholder="Enter Captcha" v-model="recaptchaData" @input="validateCaptcha" variant="outlined" style="border: 2px solid #213D77;">
                  <template v-slot:append v-if="confirmcaptcha">
                    <v-icon color="green">mdi-check-underline</v-icon>
                  </template>
                </v-text-field>
                <span v-if="!confirmcaptcha && recaptchaData" class="error-message">Captcha is incorrect.</span>
              </v-card>
            </div>

            <!-- Send Button -->
            <button class="button button-primary button-xs button-naira button-naira-up text-white mt-2" type="submit">
              <span class="icon fa-envelope-o" v-if="!subloader"></span>
              <span v-if="!subloader">Send</span>
              <v-progress-circular v-if="subloader" indeterminate color="white" size="16" class="ml-2"></v-progress-circular>
            </button>

          </v-form>
        </div>
              <div class="">
                <h5 class="text-bold follow-us mt-md-0 mt-sm-2">Contact Us</h5>
                <div style="color: white; margin-top: 10px;"><img src="../assets/icons/phonecall.png" width="18" height="18"> {{ phoneNumbers }}</div>
                <div style="color: white;margin-top: 5px;"><img src="../assets/icons/email.png" width="18" height="18"> {{ email }}</div>
                <!-- <div class="list-inline d-flex justify-center mt-sm-0" v-if="social_icons?.length > 0">
                  <a v-for="(data,index) of social_icons" :key="index" target="_blank" :href="data.url">
                    <v-icon class="social_icons">{{ data.icon_class}}</v-icon>
                  </a>
                </div> -->
              </div>
              <div class="">
                <h5 class="text-bold follow-us mt-md-0 mt-sm-2">Quick Links</h5>
                  <div style="margin-top: 8px;">
                    <div class="mt-1"><a href="/about-us" target="_blank" class="footer_content"
                        style="text-decoration: underline;font-size:16px;">About Us</a>
                    </div>
                    <div class="mt-1">
                      <a href="/privacy-policy" target="_blank" class="footer_content"
                        style="text-decoration: underline;font-size:16px;">Privacy Policy</a>
                    </div>
                    <div class="mt-1">
                      <a href="/contact-us" target="_blank" class="footer_content"
                        style="text-decoration: underline;font-size:16px;">Contact Us</a>
                    </div>
                    <div class="mt-1">
                      <a href="/terms-conditions" target="_blank" class="footer_content"
                        style="text-decoration: underline;font-size:16px;">Terms
                        of Use</a>
                    </div>
                  </div>
              </div>
              <div class="">
              <!-- <a class="d-inline-block"><img class="img-responsive center-block" :src="require('@/assets/CItiair_logo.jpg')" width="120" height="55" ></a>
                  <p style="font-size:13px;color:white;">Citiair is a search engine that compares flight, hotel, and car rental prices across multiple travel sites to help you find the best deals.</p> -->
              <h5 class="text-bold mt-md-0 mt-sm-2">We accept</h5>
              <div style="margin-top: 10px;"><img class="img-responsive" src="../assets/images/Card.png" width="180" height="30"></div>
            </div>
            </div>
            <!-- <div class="row d-flex justify-center align-center">
              <h6 class="col-md-1 col-3 mb-0 mt-2 text-center">
                <a href="/about-us" target="_blank" class="footer_content" style="text-decoration: underline;font-size:14px;">About Us</a>
              </h6>
              <h6 class="col-md-1 col-3 px-0 mb-0 mt-2 text-center">
                <a href="/contactUs" target="_blank" style="color: white; text-decoration: underline;font-size:14px;">Contact Us</a>
              </h6>
              <h6 class="col-md-1 col-3 px-0 mb-0 mt-2 text-center">
                <a href="/privacy-policy" target="_blank" class="footer_content" style="text-decoration: underline;font-size:14px;">Privacy Policy</a>
              </h6>
              <h6 class="col-md-1 col-3 px-0 mb-0 mt-2 ms-2 text-center">
                <a href="/terms-conditions" target="_blank" class="footer_content" style="text-decoration: underline;font-size:14px;">Terms of Use</a>
              </h6>
            </div> -->
            <hr style="margin-top:10px;margin-bottom:10px;">
          </div>
          <div class="container page-footer-min small py-0 pb-2">
            <div class="row justify-content-end-xs-middle">
              <div class="col-md-6 text-md-left text-center emailData mb-0">
                <h6 class="mb-0" style="font-size: 13px;" v-if="portAddress1 && portAddress2">
                  <span>{{ portAddress1 }}</span>
                  <span class="ms-2">{{ portAddress2 }}</span>
                </h6>
              </div>
              <div class="col-md-6 text-md-right text-center mb-0">
                <p class="rights text-white mb-0" style="font-size: 13px;"><span>&copy;&nbsp;</span><span class="copyright-year"></span><span>&nbsp;</span><span>All Rights Reserved</span><span>.&nbsp;</span><a class="text-white">Privacy Policy</a></p>
              </div>
            </div>
          </div>
        </footer>
  </template>
  
  <script>
  import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
  import axios from 'axios';
  export default {
    data(){
      return{
        portalAddress:"",
        social_icons:[],
        dialog1:false,
        dialog2:false,
        portal_id:"",
        portal_domain:"",
        validData: false,
        usermailbtn: true,
        portalLogo: "",
      email: "",
      subEmail: "",
      phoneNumber: "",
      phoneNumbers: "",
      subscribeApi: "",
      recaptchaData: "",
      subloader: false,
      confirmcaptcha: false,
      randomAlphabets: "",
      validEmail: true,
      showCaptcha: false, 
      isCaptchaValidated: false, 


         subEmailRules: [
          (v) => !!v || "Email is required",
          (v) =>
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Please enter a valid email",
        ],
      }
    },
    methods:{
      getConfigFunc() {
      const getConfigData = getConfigDataFromLocalStorage();
      if (getConfigData) {
        this.portalLogo = getConfigData.payload.portal_configuration.logo_path;
        this.email = getConfigData.payload.portal_configuration.email;
        this.phoneNumbers = getConfigData.payload.portal_configuration.phone
        this.subscribeApi = getConfigData.payload.portal_configuration.API_endpoints.subscriber_form;
        this.portal_domain = getConfigData.payload.portal_configuration.portal_url;
        this.portal_id = getConfigData.payload.portal_configuration.portal_id;
        this.portAddress1 = getConfigData.payload.portal_configuration.portal_footer_address1
        this.portAddress2 = getConfigData.payload.portal_configuration.portal_footer_address2
        this.social_icons = getConfigData.payload.portal_configuration.social_icons;
      }
    },
    handleSendClick() {
      this.validateEmail();

      if (this.validEmail) {
        if (this.isCaptchaValidated) {
          this.showCaptcha = false; 
          this.subscribeData();
        } else {
          this.showCaptcha = true;
          this.generateCaptcha();
        }
      }
    },
  
    subscribeData() {
      if (this.isCaptchaValidated) {
        this.subloader = true;
        const subscribeData = {
          request_type: "subscriber_form",
          email: this.subEmail,
          phone_no: this.phoneNumber || "",
          token: "djfkdjkf",
        portal_domain:this.portal_domain,
        portal_id: this.portal_id,
        whatsapp: false,
        };

        axios.post(this.subscribeApi, subscribeData, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log(response);
          this.subloader = false;
          this.resetForm();
        })
        .catch((error) => {
          console.error(error);
          this.subloader = false;
        });
      }
    },
      filter: function (evt) {
      evt = evt ? evt : window.event;
      let currentInput = evt.target.value;
      let newChar = evt.key;
      let expect = currentInput + newChar;
      if (expect.length > 6) {
        evt.preventDefault();
        return;
      }
      if (!/^[a-zA-Z]*$/.test(expect)) {
        evt.preventDefault();
      }
    },
      //  generateCaptcha() {
      //   // console.log(this.validData,'subscriSbeDatasubscribDeData...1',this.confirmcaptcha,this.subloader);
  
      //   this.generateRandomAlphabets();
      //   // console.log(this.recaptchaData,'subscriSbeDatasubscribDeData...11',this.randomAlphabets);
  
      //   this.confirmcaptcha = this.recaptchaData !== this.randomAlphabets ? false : true;
  
      //   if(this.validData && !this.confirmcaptcha){
      //     // console.log(this.validData,'subscriSbeDatasubscribDeData...3')
      //     this.recaptchaData = null;
      //     this.confirmcaptcha = false;
  
      //     if(!this.confirmcaptcha && !this.recaptchaData){
      //       // console.log(this.validData,'subscriSbeDatasubscribDeData...4')
      //       this.subloader = true;
      //     }
      //   }
  
      // },
      keyData($data) {
        if($data !== null || $data !== '' || $data || $data.length > 0){
          const getdataUpper = $data.toUpperCase();
          if (this.randomAlphabets === getdataUpper && $data === getdataUpper) {
            this.subloader = false;
            this.confirmcaptcha = true;
            this.usermailbtn = false;
          } else {
            this.subloader = true;
            this.confirmcaptcha = false;
            this.usermailbtn = true;
          }
        }
      },
      generateRandomAlphabets() {
        const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let result = '';
  
        for (let i = 0; i < 6; i++) {
          const randomIndex = Math.floor(Math.random() * alphabets.length);
          result += alphabets[randomIndex];
        }
  
        this.randomAlphabets = result;
        this.updateCanvas();
      },
      updateCanvas() {
        const canvas = this.$refs.myCanvas;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = '20px Arial';
        ctx.fillStyle = "white";
        ctx.fillText(this.randomAlphabets, 10, 40);
      },
      resetForm() {
      this.recaptchaData = "";
      this.confirmcaptcha = false;
      this.isCaptchaValidated = false;
    },
    validateEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.validEmail = emailPattern.test(this.subEmail);
    },
    generateCaptcha() {
      this.randomAlphabets = this.getRandomString();
      this.$nextTick(() => {
        this.drawCaptcha();
      });
    },
    getRandomString() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';
      return Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    },
    drawCaptcha() {
      const canvas = this.$refs.myCanvas;
      if (canvas) {
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.fillStyle = "#f8f9fa";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.font = '22px Arial bold';
        ctx.fillStyle = "#213d77";
        ctx.fillText(this.randomAlphabets, 10, 25);
      }
    },
    validateCaptcha() {
      if (this.recaptchaData === this.randomAlphabets) {
        this.confirmcaptcha = true;
        this.isCaptchaValidated = true;
      } else {
        this.confirmcaptcha = false;
        this.isCaptchaValidated = false;
      }
    },
    closeCaptchaOnOutsideClick(event) {
      if (this.showCaptcha && this.$refs.captchaContainer && !this.$refs.captchaContainer.contains(event.target)) {
        if (!this.isCaptchaValidated) {
          this.showCaptcha = false;
        }
      }
    },
    },
   

  mounted(){
    this.getConfigFunc();
    document.addEventListener("click", this.closeCaptchaOnOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeCaptchaOnOutsideClick);
  }
};
  </script>
  
<style scoped>
  @import "@/assets/style.css";
  a{
    text-decoration:none !important;
  }
  .subscribe::placeholder{
    color:lightgray;
    font-size:14px;
  }
  /* .follow-us{
    margin-left:77px;
  } */
  .footer_content{
    color:white;
  }
.footer_content:hover {
  color: #ff4d00;
}
  .social_icons{
    color:white;
    font-size:25px;
  }
  .social_icons:hover{
    color:#42d4ec !important;
    font-size:28px;
  }
  :deep(.v-none .v-input__details) 
  {
    display: none !important;
  }
  :deep(.v-none .v-field__input) 
  {
    min-height: 15px !important;
    padding: 7px !important;
    border: none !important;
  }
  .v-text-field .v-field--no-label input, .v-text-field .v-field--active input {
    padding: 4px;
}
  /* .v-field__input {
    min-height: 2vh !important;
} */
  @media screen and (max-width:480px) {
    .follow-us{
      margin-left:0px;
      margin-top:13px !important;
    }
    .emailData{
      margin-bottom:0px;
    }
  }
  </style>  